export class VehicleReleaseRequest {
  constructor(
    public readonly releaseDate: string,
    public readonly receiver: string
  ) {
  }
}
